"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textPropsToFilter = exports.defaultProps = void 0;
var defaultProps = {
  font: 'primary',
  fontSize: 'T200',
  hyphens: 'none'
};
exports.defaultProps = defaultProps;
var textPropsToFilter = ['color', 'display', 'font', 'fontSize', 'fontWeight', 'hyphens', 'isInMobileLayout', 'lineHeight', 'margin', 'shouldUseFixedFontStyle', 'textAlign', 'textDecoration', 'wordBreak'];
exports.textPropsToFilter = textPropsToFilter;